import { httpPost, httpDownload } from '../../../../utils/api.utils';
import {
    setPlanCatalogueHistoryLogsLoading
    , getPlanCatalogueHistoryLogs
    , setPlanCatalogueHistoryPageSize
    , resetPlanCatalogueHistory
    , setPlanCatalogueColSearchStr,
} from '../../../../constants/model-reducers/external/finance/history/plan-catalogue-history.settings';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});
 
const initialState = defaultState();

export const planCatalogueHistoryActions = {
    getPlanCatalogueHistoryLogs: (financePlanId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().planCatalogueHistory.HistoryTable;
        var formData = {
            FinancePlanId: financePlanId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers
        };

        dispatch({
            type: setPlanCatalogueHistoryLogsLoading,
            isLoadingTable: true
        });

        var financePlanResult = await httpPost('external/finance/getFinancePlanHistoryLogs', formData);
       
        dispatch({
            type: getPlanCatalogueHistoryLogs,
            historyTable: financePlanResult,
            isLoadingTable: false
        });
    },

    resizePlanCatalogueHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setPlanCatalogueHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    setPlanCatalogueColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().planCatalogueHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setPlanCatalogueColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },
    resetPlanCatalogueHistory: () => (dispatch, state) => {
        dispatch({
            type: resetPlanCatalogueHistory
        })
    },
    
    extractPlanCatalogueHistoryLogs: (financePlanId) => async (dispatch, state) => {
        const { Headers } = state().planCatalogueHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Plan History – ${formattedTimeZoneDate}`;

        var formData = {
            FinancePlanId: financePlanId,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/finance/getExtractFinancePlanHistoryLogs', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setPlanCatalogueHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getPlanCatalogueHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setPlanCatalogueHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setPlanCatalogueColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetPlanCatalogueHistory:
            return initialState;
        default:
            return state;
    }
}